/**
 * Registro dei Pack Guida sul frontend.
 *
 * Ogni Pack applicativo si registra qui specificando:
 *   - appKey: chiave del pack backend (deve corrispondere)
 *   - appLabel: nome visualizzato
 *   - routeTopics: mappa "/route" -> "topic" (per la guida contestuale)
 *
 * NB: la mappa route->topic e' anche fornita dal backend (endpoint
 * /api/guide/topics) e viene mergiata al bootstrap: la Foundation preferisce
 * quella lato server come Source of Truth (aggiornabile senza rebuild UI).
 */
const _registry = new Map();

export function registerPack({ appKey, appLabel, routeTopics = {} }) {
  if (!appKey) throw new Error("registerPack: appKey obbligatorio");
  _registry.set(appKey, {
    appKey,
    appLabel: appLabel || appKey,
    routeTopics: { ...routeTopics },
  });
}

export function getPack(appKey) {
  return _registry.get(appKey) || null;
}

export function listPacks() {
  return Array.from(_registry.values());
}

/**
 * Aggiorna la mappa route->topic di un Pack (usato dopo il fetch di
 * /api/guide/topics per allineare la SSoT server-side).
 */
export function updatePackTopics(appKey, routeTopics) {
  const p = _registry.get(appKey);
  if (!p) return;
  p.routeTopics = { ...p.routeTopics, ...routeTopics };
}

/**
 * Risolve il topic contestuale a partire da un pathname SPA.
 * Matching:
 *   1) exact match
 *   2) longest-prefix match (es. "/aziende/123" -> "/aziende")
 *   3) fallback: null
 */
export function resolvePackByRoute(appKey, pathname) {
  const pack = _registry.get(appKey);
  if (!pack) return null;
  const map = pack.routeTopics || {};
  if (!pathname) return null;
  if (map[pathname]) return map[pathname];
  const candidates = Object.keys(map)
    .filter((k) => pathname.startsWith(k))
    .sort((a, b) => b.length - a.length);
  return candidates.length ? map[candidates[0]] : null;
}
